const servicesMonthCertificationRoute = {
  path: 'provider',
  component: () =>
    import(
      '@/views/provider/services-month-certification-management/Wrapper.vue'
    ),
  children: [
    {
      path: '/provider/services-month-certification',
      name: 'servicesMonthCertificationSearch',
      component: () =>
        import(
          '@/views/provider/services-month-certification-management/Main.vue'
        ),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.servicesmonthcertification'],
        },
      },
    },
  ],
};

export default servicesMonthCertificationRoute;
